import { RollbackOutlined } from '@ant-design/icons'
import { Button, DatePicker, Form, Input, InputNumber, message, Select } from 'antd'
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { GetAllDocument, GetAllinvoice, GetSPInvoiceOrder, GetSPInvoiceRFNumber } from '../../../API/GetData'
import { AuthData } from '../../../Components/Global'
import InputModal from '../../../Components/InputModal'
import HeaderTitle from '../../../Components/HeaderTitle'
import dayjs from 'dayjs'
import { PostInvoice, UploadDocs } from '../../../API/PostData'
import TableFormUpload from './TableFormUpload'
import { decrypt } from '../../../Utils/CryptoHelper'
import { UpdateInvoice } from '../../../API/UpdateData'
import InvoiceSample from './InvoiceSample'

const FormInvoice = () => {

    const safeDecode = (value) => {
        try {
            return value ? decodeURIComponent(value) : '';
        } catch (e) {
            console.error('Failed to decode URI component:', value);
            return '';
        }
    };

    const params = useParams();
    const { accountid, code } = params;

    const DecAccountId = decrypt(safeDecode(accountid));
    const DecCode = decrypt(safeDecode(code));

    const [dataDocsEdit, setDataDocsEdit] = useState([]);
    const [dataRFNum, setDataRFNum] = useState([]);

    useEffect(() => {
        if (DecAccountId && DecCode) {
            const fetchInvoice = async () => {
                try {
                    const [res] = await GetAllinvoice(DecAccountId, DecCode);

                    const payload = {
                        ...res,
                        InvoiceDate: dayjs(res.InvoiceDate),
                        InvoiceDueDate: dayjs(res.InvoiceDueDate),
                    }

                    if (payload) {
                        form.setFieldsValue(payload);

                        // ORDER
                        const resINVOrder = await GetSPInvoiceOrder();
                        const [filter] = resINVOrder.filter((item) => item.OrderCode === payload.OrderCode);
                        setSelectRFNumber(filter);

                        // RFNumber
                        const resINVRFNumber = await GetSPInvoiceRFNumber(payload.OrderCode);
                        setDataRFNum(resINVRFNumber)
                    }

                } catch (error) {
                    console.error('Error fetching data:', error);
                }
            };

            const fetchDocs = async () => {
                try {
                    const res = await GetAllDocument(DecCode);
                    // console.log('Docs', res);
                    setDataDocsEdit(res);
                } catch (error) {
                    console.log(error);
                }
            }

            fetchDocs();
            fetchInvoice();

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [DecAccountId, DecCode])


    const [form] = Form.useForm();
    const navigate = useNavigate();
    const Auth = AuthData();
    const AccountId = Auth && Auth.AccountId;

    const [loading, setLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const [dataDocs, setDataDocs] = useState([]);
    const [dataInvSample, setDataInvSample] = useState([]);

    const [invoiceCode, setInvoiceCode] = useState("");

    const [dataRFNumber, setDataRFNumber] = useState([]);
    const [selectRFNumber, setSelectRFNumber] = useState("");
    const [openRFNumber, setOpenRFNumber] = useState(false);
    const OrderCode = selectRFNumber ? selectRFNumber.OrderCode : '';
    const OrderQuotation = selectRFNumber ? selectRFNumber.OrderQuotation : '';
    const RFNumber = selectRFNumber ? selectRFNumber.RFNumber : '';

    // RFNUMBER
    useEffect(() => {
        const fetchRFNumber = async () => {
            try {
                const res = await GetSPInvoiceOrder();
                // console.log([res]);
                setDataRFNumber(res);
            } catch (error) {
                console.log(error);
            } finally {
                setIsLoading(false);
            }
        }

        if (openRFNumber) {
            fetchRFNumber();
            setOpenRFNumber(false);
        }

    }, [AccountId, openRFNumber]);


    useEffect(() => {
        if (form) {
            form.setFieldsValue({
                OrderQuotation: OrderQuotation,
                RFNumber: RFNumber,
            })
        }
    }, [OrderQuotation, RFNumber, form]);


    // INVOICE CODE
    useEffect(() => {
        const fetchInvoices = async () => {
            try {
                const res = await GetAllinvoice();
                const today = new Date();
                // Format tanggal menjadi MMDD (bulan dan hari)
                const month = (today.getMonth() + 1).toString().padStart(2, "0");
                const day = today.getDate().toString().padStart(2, "0");
                const datePrefix = `${month}${day}`;

                if (res.length > 0) {
                    // Filter invoice dengan prefix INV dan tanggal hari ini
                    const todayPrefix = `INV${datePrefix}`;
                    const filteredData = res.filter(item => item.InvoiceCode.startsWith(todayPrefix));

                    if (filteredData.length > 0) {
                        // Ambil nomor terakhir dan tambahkan 1
                        const lastInvoice = filteredData[filteredData.length - 1].InvoiceCode;
                        const lastNumber = parseInt(lastInvoice.substring(7)); // 7 karakter: INV + MMDD
                        const nextNumber = lastNumber + 1;
                        const nextNo = `INV${datePrefix}${nextNumber.toString().padStart(3, "0")}`;
                        setInvoiceCode(nextNo);
                    } else {
                        setInvoiceCode(`INV${datePrefix}001`);
                    }
                } else {
                    setInvoiceCode(`INV${datePrefix}001`);
                }
            } catch (error) {
                console.log(error);
            }
        }
        fetchInvoices();
    }, []);

    useEffect(() => {
        if (form && invoiceCode && !DecAccountId && !DecCode) {
            form.setFieldsValue({
                InvoiceCode: invoiceCode,
                InvoiceDate: dayjs(),
                PaymentStatus: "UNPAID",
                Status: "Process"
            })
        }
    }, [DecAccountId, DecCode, form, invoiceCode]);


    const handleSubmit = async (values) => {
        try {
            setLoading(true);

            const payload = {
                ...values,
                AccountId: AccountId,
                OrderCode: OrderCode,
                InvoiceDate: dayjs(values.InvoiceDate).format("YYYY-MM-DD"),
                InvoiceDueDate: dayjs(values.InvoiceDueDate).format("YYYY-MM-DD"),
                InvoiceSample: dataInvSample
            };

            const uploadPromises = [];

            if (dataDocs.length > 0) {
                for (const item of dataDocs) {
                    if (!item.FileUpload || !item.FileUpload.fileList || item.FileUpload.fileList.length === 0) {
                        console.warn("FileUpload kosong untuk item:", item);
                        continue;
                    }

                    for (const file of item.FileUpload.fileList) {
                        const fileObj = file.originFileObj;
                        const fileName = file.name;

                        if (!fileObj) {
                            console.warn("File tidak ditemukan dalam fileList:", file);
                            continue;
                        }

                        const filePayload = new FormData();
                        filePayload.append("AccountId", AccountId);
                        filePayload.append("RefNo", payload.InvoiceCode);
                        filePayload.append("DocNo", item.key);
                        filePayload.append("FileName", item.FileName);
                        filePayload.append("DocType", item.DocType);
                        filePayload.append("IsSuspend", false);
                        filePayload.append("fileUploads", fileObj, fileName);

                        const uploadPromise = UploadDocs(filePayload).then((res) => {
                            if (res.status !== 200) {
                                throw new Error(`Gagal mengunggah file: ${fileName}`);
                            }
                        }).catch((err) => {
                            console.error(`Gagal mengunggah file ${fileName}:`, err);
                        });

                        uploadPromises.push(uploadPromise);
                    }
                }

                // Tunggu semua proses upload selesai
                await Promise.all(uploadPromises);
            }

            let response = null;
            if (DecAccountId && DecCode) {
                response = await UpdateInvoice(DecAccountId, DecCode, payload);
            } else {
                response = await PostInvoice(payload);
            }

            if (response.status === 201 || response.status === 200) {
                message.success(response.data.message);
                navigate('/dashboard/invoice');
            }

        } catch (error) {
            console.log(error);
            message.error(error?.response?.data?.message || "Terjadi kesalahan.");
        } finally {
            setLoading(false);
        }
    };


    const handleReset = async () => {
        form.resetFields();
        setSelectRFNumber("");
    }

    return (
        <>
            <div className="flex justify-between items-center">
                <HeaderTitle title="INVOICE" subtitle="Form a Invoice" />
                <Button icon={<RollbackOutlined />} onClick={() => navigate(-1)}>Back</Button>
            </div>

            <div className="bg-white p-4 rounded-md mt-4">
                <Form
                    name="formOrder"
                    layout="vertical"
                    onFinish={handleSubmit}
                    autoComplete="off"
                    form={form}
                >
                    {/* <h1 className="text-xl font-semibold border-b-2 pb-1 mb-2">Informasi Invoice</h1> */}
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">

                        <Form.Item
                            label="Invoice Code"
                            name="InvoiceCode"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your Invoice Code!',
                                },
                            ]}
                        >
                            <Input placeholder="Invoice Code" disabled />
                        </Form.Item>

                        <Form.Item
                            label="Invoice Date"
                            name="InvoiceDate"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your Invoice Date!',
                                },
                            ]}
                        >
                            <DatePicker placeholder="Invoice Date" className="w-full" />
                        </Form.Item>

                        <InputModal
                            title="RFNumber"
                            label="RF Number"
                            name="RFNumber"
                            dataSource={dataRFNumber}
                            loading={isLoading}
                            columns={columnsRFNumber}
                            onData={(values) => setSelectRFNumber(values)}
                            onOpenModal={(values) => setOpenRFNumber(values)}
                        />

                        <Form.Item
                            label="Order Quotation"
                            name="OrderQuotation"
                        >
                            <Input placeholder="Order Quotation" disabled />
                        </Form.Item>

                        <Form.Item
                            label="Invoice Due Date"
                            name="InvoiceDueDate"
                        >
                            <DatePicker placeholder="Invoice Due Date" className="w-full" />
                        </Form.Item>

                        {/* <Form.Item
                            label="Invoice Sent Date"
                            name="InvoiceSentDate"
                        >
                            <DatePicker placeholder="Invoice Sent Date" className="w-full" />
                        </Form.Item> */}

                        <Form.Item
                            label="Payment Status"
                            name="PaymentStatus"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your Payment Status!',
                                },
                            ]}
                        >
                            <Select
                                placeholder="Invoice Status"
                                options={[
                                    {
                                        value: 'UNPAID',
                                        label: 'UNPAID',
                                    },
                                    {
                                        value: 'PENDING REVIEW',
                                        label: 'PENDING REVIEW',
                                    },
                                    {
                                        value: 'REVISION NEEDED',
                                        label: 'REVISION NEEDED',
                                    },
                                    {
                                        value: 'PAID',
                                        label: 'PAID',
                                    },
                                    {
                                        value: 'REJECT',
                                        label: 'REJECT',
                                    },
                                ]}
                            />
                        </Form.Item>

                        <Form.Item
                            label="NET"
                            name="NET"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your NET!',
                                },
                            ]}
                        >
                            <InputNumber
                                placeholder="NET"
                                formatter={(value) =>
                                    `Rp ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
                                }
                                parser={(value) =>
                                    value?.replace(/Rp\s?|(\.*)/g, '')
                                }
                                className="w-full"
                            />
                        </Form.Item>

                        <Form.Item
                            label="Status"
                            name="Status"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your Status!',
                                },
                            ]}
                        >
                            <Select
                                allowClear
                                placeholder="Select Status"
                                options={[
                                    {
                                        value: 'Process',
                                        label: 'Process',
                                    },
                                    {
                                        value: 'Published',
                                        label: 'Published',
                                    },
                                    {
                                        value: 'Cancel',
                                        label: 'Cancel',
                                    },
                                ]}
                            />
                        </Form.Item>

                        <Form.Item
                            label="Description"
                            name="Description"
                            className="lg:col-span-2"
                        >
                            <Input.TextArea placeholder="Description" rows={4} />
                        </Form.Item>

                    </div>

                    <div className="border pt-4 rounded-md">
                        <TableFormUpload
                            onSaveData={(values) => setDataDocs(values)}
                            onEditData={dataDocsEdit}
                        />
                    </div>

                    <div className="border pt-4 rounded-md mt-4">
                        <InvoiceSample
                            onSaveData={(value) => setDataInvSample(value)}
                            onEditData={dataRFNum}
                            OrderCode={OrderCode}
                        />
                    </div>

                    <div className="flex justify-end gap-2 mt-4">
                        <Button type="primary" htmlType="submit" loading={loading}>Submit</Button>
                        <Button htmlType="button" onClick={handleReset}>Reset</Button>
                    </div>

                </Form>
            </div>
        </>
    )
}

export default FormInvoice;

const columnsRFNumber = [
    {
        key: "OrderQuotation",
        title: "Order Quotation",
        dataIndex: "OrderQuotation"
    },
    {
        key: "RFNumber",
        title: "RF Number",
        dataIndex: "RFNumber"
    },
    {
        key: "CustomerName",
        title: "Customer Name",
        dataIndex: "CustomerName"
    },
    {
        key: "ContactPerson",
        title: "Contact Person",
        dataIndex: "ContactPerson",
        render: (value) => value ? value : '-'
    },
    {
        key: "Address",
        title: "Address",
        dataIndex: "Address",
        render: (value) => value ? value : '-'
    },
];
